import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-118a9f99"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "name-tag" }

import {} from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'name-tag',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, "建设中"))
}
}

})